import type { FC, PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSessionStore } from '@/entities/session';

const PublicRoute: FC = ({
  redirectPath = '/',
}: PropsWithChildren<{ redirectPath?: string }>) => {
  const { session } = useSessionStore();

  return !session ? <Outlet /> : <Navigate to={redirectPath} replace />;
};

export default PublicRoute;
